import Konva from 'konva/konva'

const offset = 1
const cornerRadius = 3
const background = 'rgba(255,255,255,0.8)'
const labelFont = { family: 'Roboto', size: 12, color: 'rgba(0,0,0,0.54)' }
const padding = 2
const tickLine = { length: 5, color: 'Grey', width: 1 }

export default class YScaleLabel extends Konva.Group {
  constructor ({ scaleWidth, y, text }) {
    super({ y })
    Object.assign(this, { scaleWidth, text })

    this._render()
  }

  _render () {
    this._renderTick()
    this._renderLabel()
  }

  _renderTick () {
    const tick = new Konva.Line({
      points: [0, 0, tickLine.length, 0],
      stroke: tickLine.color,
      strokeWidth: tickLine.width
    })
    this.add(tick)
  }

  _renderLabel () {
    const { scaleWidth, text } = this
    const label = new Konva.Label({ x: scaleWidth - offset })

    label.add(new Konva.Tag({
      fill: background,
      cornerRadius,
      pointerDirection: 'right'
    }))

    label.add(new Konva.Text({
      text: String(text), // accept 0 values!
      fontFamily: labelFont.family,
      fontSize: labelFont.size,
      fill: labelFont.color,
      padding
    }))

    this.add(label)
  }
}
